import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _DOCTISSIMO_TAXONOMIE;

import { MAIN_SECTION } from "./main-section";
import { PERSON_TYPE } from "./person-type";
import { DoctissimoTaxonomyName } from "./taxonomyName";
var DOCTISSIMO_TAXONOMIES = (_DOCTISSIMO_TAXONOMIE = {}, _defineProperty(_DOCTISSIMO_TAXONOMIE, DoctissimoTaxonomyName.PersonType, PERSON_TYPE), _defineProperty(_DOCTISSIMO_TAXONOMIE, DoctissimoTaxonomyName.MainSection, MAIN_SECTION), _DOCTISSIMO_TAXONOMIE);
export * from "./taxonomyName";
export { DOCTISSIMO_TAXONOMIES };